import * as React from 'react';
import { useSelector } from 'react-redux';
import * as ReactDOMServer from 'react-dom/server';
import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import {
  getMapApiKey,
  getLocationCenterCoordinates,
  getFilteredResidentialComplexes,
  getResidentialComplexes,
} from 'shared/selectors';
import { Map as MapComponent } from 'shared/components/Map';
import { getPins } from './helpers';
import { MapBalloon as MapBalloon__DEPRECATED } from '../MapBalloon';
import { MapBalloon } from './internal/components/MapBalloon';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { extractUndefined } from 'shared/utils/extractUndefined';
import { RoomsInfoItem } from 'shared/components/RoomsList';

const defaultRoomsInfo = Array.of<RoomsInfoItem>();

export function Map() {
  const { config } = useApplicationContext();
  const apiKey = useSelector(getMapApiKey);
  const { hash, list } = useSelector(getResidentialComplexes);
  const [pinTypes, setPinTypes] = React.useState<string[]>([]);
  const filteredComplexes = useSelector(getFilteredResidentialComplexes);
  const { center, zoom } = useSelector(getLocationCenterCoordinates);

  const handleGeoObjectsFirstFetch = (): Promise<IMapGeoObject[]> => {
    const pins = getPins(list);

    return Promise.resolve(pins);
  };

  const handleBalloonHtmlFirstFetch = (geoObject: IMapGeoObject) => {
    const numberedId = Number(geoObject.options.id);
    const complex = hash[numberedId];

    if (!complex) {
      return { html: Promise.reject(new Error('Не верный тип пина!')) };
    }

    /**
     * @todo Удалить фича тоггл
     * @description Данный функционал появился в задаче CD-240410, будет удалён в задаче CD-241279
     * Не забудь удалить из scheme.json
     */
    const pikLandingBlocksUpdateEnabled = config.get<boolean>('PikLanding.BlocksUpdate.Enabled');

    const roomsInfo = complex.roomsInfo || defaultRoomsInfo;
    const subtitle = extractUndefined(complex.finishInfo?.label);
    const promoLabel = extractUndefined(complex.promoLabel);
    const imageUrl = complex.imgUrl || complex.fullImgUrl || '';

    return {
      html: Promise.resolve(
        ReactDOMServer.renderToStaticMarkup(
          pikLandingBlocksUpdateEnabled ? (
            <MapBalloon
              promoLabel={promoLabel}
              roomsInfo={roomsInfo.length > 6 ? roomsInfo.slice(0, 6) : roomsInfo}
              title={complex.title}
              subtitle={subtitle}
              transports={complex.transports}
              imageUrl={imageUrl}
              url={complex.publicUrl}
            />
          ) : (
            <MapBalloon__DEPRECATED complex={complex} />
          ),
        ),
      ),
      closeSelector: '#close',
    };
  };

  React.useEffect(() => {
    setPinTypes(filteredComplexes.map(complex => String(complex.id)));
  }, [filteredComplexes]);

  return (
    <MapComponent
      apiKey={apiKey}
      pinCoordinates={center}
      zoom={zoom}
      currentTypes={pinTypes}
      onGeoObjectsFirstFetch={handleGeoObjectsFirstFetch}
      onCustomBalloonHtmlFetch={handleBalloonHtmlFirstFetch}
    />
  );
}
